export default __webpack_public_path__ + "static/media/Key.0b463585.svg";